const isMergeableObject = (value) => value && typeof value === 'object' && !Array.isArray(value);

/*
 * JSON Merge Patch (RFC 7396): objects merge recursively, arrays and scalars replace wholesale, and a null value
 * deletes the target key (tombstone). The one merge for a workflow step patch on both sides of the API boundary:
 * the API applies it to the draft (workflowStepUpdate), and the renderer applies the same patch to its copy while
 * the write is in flight, so the editor shows exactly what the server will store.
 */
export const mergePieveWorkflowPatch = ({ target, patch } = {}) => {
  if (!isMergeableObject(patch)) {
    return patch;
  }

  const safeTarget = isMergeableObject(target) ? { ...target } : {};

  Object.keys(patch).forEach((key) => {
    const patchValue = patch[key];

    if (patchValue === null) {
      delete safeTarget[key];
      return;
    }

    if (isMergeableObject(patchValue)) {
      safeTarget[key] = mergePieveWorkflowPatch({
        target: safeTarget[key],
        patch: patchValue
      });
      return;
    }

    safeTarget[key] = patchValue;
  });

  return safeTarget;
};
